import { CanActivateChildFn, CanActivateFn } from '@angular/router';


/**
 * Create a sequential guard that runs multiple guards in sequence. If any guard returns a value other than true, this value is returned
 * immediately. If all guards pass, true is returned.
 *
 * @param {Array<T>} guards The guards to run in sequence.
 * @returns {CanActivateFn | CanActivateChildFn} A guard that runs all inner guards in sequence.
 */
export function createSequentialGuard<T extends CanActivateFn | CanActivateChildFn>(guards: Array<T>): CanActivateFn | CanActivateChildFn {
  return (route, state) => {
    // Run all guards sequentially in the order they have been defined in the array
    for (const guard of guards) {
      const result = guard(route, state);

      if (result !== true) {
        // If a guard returns something other than true, return this value immediately
        return result;
      }
    }

    // If all guards have passed, return true
    return true;
  };
}
